import React from 'react';
import { Landmark } from 'lucide-react';
import { useTheme } from '../components/ThemeContext';

const SenateTrades: React.FC = () => {
  const { theme } = useTheme();
  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-theme-primary' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="mb-8">
          <h1 className={`text-3xl font-bold mb-2 ${theme === 'dark' ? 'text-theme-primary' : 'text-gray-900'}`}>Senate Trades</h1>
          <p className={`text-sm ${theme === 'dark' ? 'text-theme-muted' : 'text-gray-600'}`}>Tracking publicly disclosed US Senate trades (placeholder).</p>
        </div>
        <div className={`rounded-lg border p-8 flex flex-col items-center justify-center text-center ${theme==='dark' ? 'border-theme-tertiary bg-theme-secondary' : 'border-gray-200 bg-white'}`}>
          <Landmark className="w-12 h-12 text-red-500 mb-4" />
          <p className={`text-sm ${theme==='dark' ? 'text-theme-secondary' : 'text-gray-700'}`}>Senate Trades resource module coming soon.</p>
        </div>
      </div>
    </div>
  );
};

export default SenateTrades;

